// Vendor Libs
import React, {Component} from 'react';
import PropTypes from 'prop-types';

// Components
import Error from '../core/error';
import Loading from '../core/loading';
import LockedIndicator from './locked-indicator';
import CreateMediaItemOffering from './create-mediaitem-offering';
import EditMediaItemOffering from './edit-mediaitem-offering';

// Containers
import withSearch from '../../containers/with-search';

// Styles
import './create-edit-mediaitem-offering.scss';

const servicesDataKey = 'mediaItemDetail';

class CreateEditMediaItemOffering extends Component {
    state = {
        editing: true,
        editIndex: 0,
    };

    componentWillUpdate(nextProps) {
        const {searchData: [{guid} = {}] = {}} = this.props;
        const {searchData: [{guid: nextGuid} = {}] = {}} = nextProps;

        if (nextGuid && guid !== nextGuid) {
            this.setState({
                editing: true,
                editIndex: 0,
            });
        }
    }

    getProps() {
        const {editIndex} = this.state;

        return {
            editIndex,
            className: 'create-edit-mediaitem-offering',
            setEditCreateState: this.setEditCreateState,
            setEditIndex: this.setEditIndex,
        };
    }

    setEditCreateState = (editing) => {
        this.setState({editing});
    };

    setEditIndex = (editIndex) => {
        this.setState({editIndex});
    };

    renderForm() {
        const {editing} = this.state;

        return editing ? (
            <EditMediaItemOffering {...this.getProps()} />
        ) : (
            <CreateMediaItemOffering {...this.getProps()} />
        );
    }

    render() {
        const {fetching, routerParams, searchData: [{guid} = {}] = {}} = this.props;

        return routerParams.guid ? (
            <div className="create-edit-mediaitem-offering">
                <Loading loading={fetching} />
                {guid ? (
                    <>
                        <LockedIndicator detail={true} lockId={guid} recordLabel="Media Item" serviceKey="mediaItems" />
                        {this.renderForm()}
                    </>
                ) : (
                    <Error error="Choose a record." />
                )}
            </div>
        ) : (
            <Error error="Choose a record." />
        );
    }
}

CreateEditMediaItemOffering.propTypes = {
    fetching: PropTypes.bool,
    routerParams: PropTypes.object.isRequired,
    searchData: PropTypes.array,
};

export default withSearch(CreateEditMediaItemOffering, servicesDataKey);
